import { appLoaderType } from '../action/types';

const initialState = {
    isLoader: false,
    // NMU-524: what the overlay is waiting for, when the caller says.
    message: null
}

const appLoaderReducer = (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case appLoaderType.DISABLE:
            return {
                ...state,
                isLoader: false,
                message: null
            }
        case appLoaderType.ENABLE:
            return {
                ...state,
                isLoader: true,
                message: action.message || null
            }
        default:
            return state;
    }
}

export default appLoaderReducer;